import React from 'react';
const problems = ['Arrivi al campo senza un piano preciso', 'Passi ore a cercare esercizi online', 'Hai gruppi con livelli molto diversi', 'I bambini si annoiano facilmente', 'Devi adattare continuamente gli allenamenti', "Non sai cosa insegnare in ogni fascia d'età", 'Ti senti sempre in ritardo con la programmazione', 'Quando mancano giocatori devi improvvisare'];
export function ProblemSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-160">
      <div className="max-w-3xl mx-auto text-center" data-id="element-161">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#0A0A0A] mb-10 tracking-tight leading-tight" data-id="element-162">
          Se alleni calcio giovanile, probabilmente stai vivendo almeno uno di
          questi problemi:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left mb-12" data-id="element-163">
          {problems.map((problem, i) => <div key={i} className="flex items-start gap-3 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-4 shadow-sm" data-id="element-164">
              <span className="text-red-500 text-xl flex-shrink-0" data-id="element-165">❌</span>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-semibold leading-snug" data-id="element-166">
                {problem}
              </p>
            </div>)}
        </div>

        <p className="text-[#16A34A] text-2xl sm:text-4xl font-black mb-8 tracking-tight" data-id="element-167">
          Quanti allenamenti ancora vuoi improvvisare?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#E5E5EA] to-transparent w-full" data-id="element-168" />
      </div>
    </section>;
}